import type { Moment } from 'moment';

/**
 * Date 域类型权威定义。
 *
 * @canonical 5.3-domain-owned-types
 * @归属 date/filter 日期筛选相关领域。
 */

/** 时间粒度：与后端粒度字符串和 Moment 映射 key 对齐。 */
export const DateGranularity = {
  HOUR: 'hour',
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
} as const;

export type TDateGranularity =
  (typeof DateGranularity)[keyof typeof DateGranularity];

/**
 * 日期筛选运算符（动态/静态日期区间）。
 *
 * @core filter 域 `DBColumnType`、Dashboard TopFilter、SortableDrag 日期筛选共用。
 */
export const DateFilterOperation = {
  Between: 'between',
  Recent: 'recent',
} as const;

export type TDateFilterOperation =
  (typeof DateFilterOperation)[keyof typeof DateFilterOperation];

/** 日期选择类型：动态日期或静态日期。 */
export const DateShowType = {
  DYNAMIC: 'dynamicDate',
  STATIC: 'staticDate',
} as const;

export type TDateShowType = (typeof DateShowType)[keyof typeof DateShowType];
export type TDateRange = [string | Moment, string | Moment];

export type TRelativeTime = {
  name_cn: string;
  name_en: string;
  last_time: string;
  granularity: TDateGranularity;
  time_range?: [string, string];
  value?: string;
  is_custom: boolean;
  is_active?: boolean;
};
